<template>
  <v-tile
    :product="product"
    class="c-tile--default"
  >
    <div
      class="c-tile--default__wrapper"
      @mouseenter="toggleHover"
      @mouseleave="toggleHover"
    >
      <v-product-image
        :product="product"
        class="c-tile__image"
      ></v-product-image>
    </div>
    <div class="c-tile__info u-color-primary">
      <h3
        v-dompurify-html="title"
        class="o-typography__title2"
      ></h3>
    </div>
    <v-progress
      v-if="$section.tileProgress"
      :product="product"
      class="c-tile__progress"
    ></v-progress>
    <v-badge
      :product="product"
      class="c-tile__badge"
      :counting="isHovered"
    ></v-badge>
  </v-tile>
</template>
<script>
  import { VBadge, VProductImage, VProgress, VTile } from '@/index/shared/components';
  import { meta } from '@/index/shared/filters';

  export default {
    components: {
      VProductImage,
      VProgress,
      VTile,
      VBadge,
    },
    filters: {
      meta,
    },
    inject: ['$section'],
    props: {
      product: Object,
    },
    data() {
      return {
        isHovered: false,
        keys: ['richTitle', 'rating'],
      };
    },
    computed: {
      title() {
        return meta(this.product, this.keys);
      },
    },
    methods: {
      toggleHover() {
        this.isHovered = !this.isHovered;
      },
    },
  };
</script>
